import styled, { css } from "styled-components/native";
import { light_black } from "../../StyleHelpers";

export const StyledMainContent = styled.View<{ isNarrow?: boolean }>`
	display: flex;
	width: 100%;
	height: 100%;
	flex-direction: column;
	align-items: center;
	background-color: ${light_black};

	${(isNarrow) =>
		!isNarrow &&
		css`
			padding-top: 11.3rem;
		`}

	${(isNarrow) =>
		isNarrow &&
		css`
			justify-content: center;
		`}
`;

export const StyledFrame = styled.View<{ isNarrow?: boolean }>`
	display: flex;
	flex-direction: column;
	align-items: center;
	gap: 2rem;
	gap: ${({ isNarrow }) => (isNarrow ? "1rem" : "2rem")};
`;

export const StyledTextContainer = styled.View`
	align-items: center;
	justify-content: space-between;
	display: flex;
	margin-top: 4%;
`;
